module.exports = __webpack_public_path__ + "img/company_logo_13.791e65c9.png";